export default __webpack_public_path__ + "static/reaction-marketing-141f4a21dcfee95121687489a36548ba.png";